import Slider from "react-slick";
import { motion } from "framer-motion";

import img1 from "../assets/gallery1.webp";
import img4 from "../assets/gallery4.webp";
import img5 from "../assets/gallery5.webp";
import img6 from "../assets/gallery6.webp";

export default function GalleryCarousel() {
  const images = [
    { src: img1, caption: "Powerful Smash Training" },
    { src: img4, caption: "Dynamic Group Sessions" },
    { src: img5, caption: "1-on-1 Elite Coaching" },
    { src: img6, caption: "Mastering Footwork" },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnHover: true,
    arrows: true,
  };

  return (
    <motion.section
      className="gallery-carousel"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <h2>Our Coaching Moments</h2>

      <Slider {...settings}>
        {images.map((img, i) => (
          <div key={i} className="slide">
            <div className="image-wrapper">
              <img src={img.src} alt={img.caption} />
              <div className="overlay">
                <p>{img.caption}</p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </motion.section>
  );
}
